import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import HighlightText from '../components/HighlightText'
import FeaturesHeading from '../components/FeaturesHeading'

const NbnFeatures = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [features, setFeatures] = useState([])

    useEffect(() => {
        DataSource.getData('/api/getContent/nbn/features', response => {
            setFeatures(response.features)
            setIsLoaded(true)
        })
    }, [])

    const HeadingDesktop = <React.Fragment>When it comes to<br /><HighlightText height='16px'>nbn&trade; plan features</HighlightText>,<br />we've got you covered</React.Fragment>
    const HeadingMobile = <span>When it comes<br />to <HighlightText>nbn&trade; plan features</HighlightText>,<br />we've got you covered</span>

    return (
        <FeaturesHeading
            features={features}
            headingDesktop={HeadingDesktop}
            headingMobile={HeadingMobile}
            hasBgTop={props.hasBgTop}
            className={props.className}
            hasBasicHeading={props.hasBasicHeading}
            isLoaded={isLoaded}
        />
    )
}

NbnFeatures.propTypes = {
    className: PropTypes.string,
    hasBgTop: PropTypes.bool,
    hasBasicHeading: PropTypes.bool
}

export default NbnFeatures



// WEBPACK FOOTER //
// ./resources/js/nbn/NbnFeatures.js